module.exports = __webpack_public_path__ + "img/stamp-island-designer-brown.3eaeb55a.png";